function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

class Logger {}

_defineProperty(Logger, "log", (method, message, obj, objName = 'Obj') => {
  if (window.__debug__) {
    const currentDate = new Date().toLocaleDateString('es-ES', {
      year: 'numeric',
      month: 'long',
      day: 'numeric'
    });
    console.log("%c [INFO]: ".concat(currentDate, " |  %c ").concat(method, " | ").concat(message), 'background: blue; color: white; display: block;', 'background: green; color: white; display: block;');

    if (obj) {
      console.group(objName);
      console.log(obj);
      console.groupEnd();
    }
  }
});

export default Logger;